module.exports = __webpack_public_path__ + "img/wallet_mb_04.e6d68632.png";